export const APP_NAME = 'Payli BI';
export const APP_DESCRIPTION = 'Plataforma de inteligencia de negocios para análisis y gestión.';
